"use client";

import * as React from "react";
import { ImageCarousel, type ImageCarouselImage } from "@/ui/components/ui/image-carousel";
import { ProductImageLightbox } from "@/ui/components/pdp/product-image-lightbox";

interface ProductGalleryProps {
	images: ImageCarouselImage[];
	productName: string;
}

/**
 * Product Gallery with mobile swipe support.
 *
 * Features:
 * - Horizontal swipe on mobile (Embla Carousel)
 * - Arrow navigation on desktop (hover to reveal)
 * - Thumbnail strip on desktop
 * - Dot indicators on mobile
 * - First image uses preload + high/eager priority for LCP optimization
 * - Tap/click main image or thumbnail opens full-screen lightbox
 */
export function ProductGallery({ images, productName }: ProductGalleryProps) {
	const [lightboxOpen, setLightboxOpen] = React.useState(false);
	const [lightboxIndex, setLightboxIndex] = React.useState(0);

	const openLightbox = React.useCallback((index: number) => {
		setLightboxIndex(index);
		setLightboxOpen(true);
	}, []);

	return (
		<>
			<ImageCarousel
				images={images}
				productName={productName}
				showArrows={true}
				showDots={true}
				showThumbnails={true}
				onImageClick={openLightbox}
				onThumbnailClick={openLightbox}
			/>
			<ProductImageLightbox
				open={lightboxOpen}
				onOpenChange={setLightboxOpen}
				images={images}
				initialIndex={lightboxIndex}
				productName={productName}
			/>
		</>
	);
}
